import { render, staticRenderFns } from "./lithiumReportTem.vue?vue&type=template&id=0ca0f1bc&scoped=true"
import script from "./lithiumReportTem.vue?vue&type=script&lang=js"
export * from "./lithiumReportTem.vue?vue&type=script&lang=js"
import style0 from "./lithiumReportTem.vue?vue&type=style&index=0&id=0ca0f1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0f1bc",
  null
  
)

export default component.exports